import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import {Typography} from '@mui/material';
import {openDialog} from '../../../redux/slices/reportsDialogSlice';
import {getUTCDateTimeForDisplay} from '../../../utils/utils';
import AurButton from '../../common/aur-button/AurButton';
import {ReactComponent as ExchangeIcon} from '../../../../src/assests/svg/icon_shift.svg';
import {t} from 'i18next';
import ProjectWorkSpaceSelectionDialog from '../HostingUserSummaryReport/WorkSpaceSummary/ProjectWorkSpaceSelectionDialog';
import ProjectWorkSpaceSelection from '../HostingUserSummaryReport/WorkSpaceSummary/ProjectWorkSpaceSelection';
import AurHighlyConfidential from '../../common/aur-highly-confidential/AurHighlyConfidential';
import {AurLightTooltip} from '../../common/aur-light-tooltip/aur-light-tooltip';

const InTakeAuditHeader = () => {
  const dispatch = useDispatch();

  const {
    refreshDates,
    selectedProjectName: projectName,
    selectedWorkSpaceName: workSpaceName,
    currentProject: selectedProject,
  } = useSelector((state: RootState) => state.reports);

  const handleOpenDialog = () => {
    dispatch(openDialog());
  };

  return (
    <div className="intake-audit-header">
      {selectedProject?.highlyConfidential && (
        <AurHighlyConfidential
          type="pill"
          showWarningText={true}
          className="highly-confidential-alert"
        />
      )}
      <div>
        <Typography className="typo-text subhead3_size" component="h1">
          {projectName}
        </Typography>
      </div>
      <div className="intake-audit-sub-title">
        <Typography className="typo-text display3_size">
          {workSpaceName}
        </Typography>
        <AurButton
          ariaLabel={`${t('reports.inTakeAuditTab.header.projectButton')} | ${t('reports.inTakeAuditTab.header.workspaceButton')}`}
          classNames="typo-text buttonMedium_size"
          onClick={handleOpenDialog}
          type="continue"
          size="Medium"
          startIcon={<ExchangeIcon aria-hidden />}
          dataTestId="open-project-workspace-dialog"
        >
          {t('reports.inTakeAuditTab.header.projectButton')}{' '}
          <span className="color-button-divider"> | </span>{' '}
          {t('reports.inTakeAuditTab.header.workspaceButton')}{' '}
        </AurButton>
        <ProjectWorkSpaceSelectionDialog
          ContentComponent={ProjectWorkSpaceSelection}
          openFrom={t('reports.projectOverview.tabs.tabIntakeAudit')}
          hideNonConsilioProjects={!selectedProject?.isNonConsilioWorkflow}
        />
      </div>
      <div className="intake-audit-date-section">
        <Typography className="typo-text body3_size">
          {t('reports.inTakeAuditTab.header.dateAsOf')}{' '}
          <AurLightTooltip title={t('common.yearMonthDate')}>
            <span className="typo-text label1_size intake-audit-date-sub-section">
              {getUTCDateTimeForDisplay(refreshDates.intakeAudit || '')}
            </span>
          </AurLightTooltip>
        </Typography>
        <Typography className="typo-text body3_size">
          {t('reports.inTakeAuditTab.header.description')}
        </Typography>
      </div>
    </div>
  );
};

export default InTakeAuditHeader;
